module.exports = __webpack_public_path__ + "img/pin_substitution_purple.22873347.svg";